/**
 * Month-range wording for ledger periods — shared by the ledgers drawer and
 * the Reconciler's tracker, so "what we asked for" and "what they sent" read
 * the same way everywhere.
 */

const MONTH = (iso) =>
  new Date(`${iso.slice(0, 7)}-01T00:00:00Z`).toLocaleDateString('en-IN', { month: 'short', timeZone: 'UTC' })

/** `Apr – Aug 2026`, `Sep 2026`, `Mar 2026 – Apr 2027`. */
export function monthRange(from, to) {
  if (!from || !to) return null
  const fy = from.slice(0, 4)
  const ty = to.slice(0, 4)
  if (from.slice(0, 7) === to.slice(0, 7)) return `${MONTH(from)} ${fy}`
  return fy === ty ? `${MONTH(from)} – ${MONTH(to)} ${ty}` : `${MONTH(from)} ${fy} – ${MONTH(to)} ${ty}`
}

/** Is this the first day of an Indian financial year (1 April)? */
const isFyStart = (iso) => Boolean(iso) && iso.slice(5) === '04-01'

/**
 * What we're asking this client for: from the period's start till date,
 * shown as a month range ending in `to` (today's month, or the month their
 * statement arrived) — `FY – Sep 2026`, or `Aug – Sep 2026` for a client whose
 * ask didn't start at the financial year.
 */
export function askRange(from, to) {
  if (!from || !to) return null
  if (isFyStart(from)) return `FY – ${MONTH(to)} ${to.slice(0, 4)}`
  return monthRange(from, to)
}
